import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const getCSVLastUploadDate = (fileName, isCustomLogin) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.GET_CSV_LAST_UPLOAD_DATE(fileName, isCustomLogin)
  );
};

export default getCSVLastUploadDate;
